import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import useUserDetails from "../useUserDetails/useUserDetails";

const useSentryIdentify = () => {
  const { userId, email, phone, fullName, gender, age } = useUserDetails();

  useEffect(() => {
    if (userId) {
      Sentry.setUser({
        id: userId,
        email: email ?? "",
        username: fullName ?? "",
      });
    }
  }, [email, fullName, gender, phone, userId, age]);
};

export default useSentryIdentify;
